import React from "react";
import { Link } from "react-router-dom";

export const Slide1 = () => {
  return (
    <React.Fragment>
      <div className="mx-auto px-5 mt-1 flex flex-col items-center md:items-start justify-evenly md:flex-row">
        {/* Left div item md:w-1/2 */}
        <div className="flex flex-col font-poppins items-center md:items-start md:mt-2 space-y-8 ">
          <span className="max-w-md text-4xl font-bold text-center text-primary md:text-6xl md:font-extrabold md:text-left md:max-w-xl">
            0% SODIUM 100% REFRESHMENT
            <p className="font-normal text-P14 md:text-xl ">
              CLEAN AND REFRESHING HYDRATION DESIGNED FOR TODAY'S
              HEALTH-CONSCIOUS LIFESTYLE
            </p>
          </span>
          <p className="max-w-md font-normal text-C12 text-justify text-darkTextColor md:max-w-xl">
            Zulal Zero Sodium is a premium drinking water crafted for consumers
            seeking pure, refreshing hydration without sodium. Through advanced
            purification processes, Zulal delivers a clean taste and exceptional
            quality while maintaining 0% sodium content. Whether you're at home,
            at work, or on the move, Zulal Zero Sodium provides a refreshing
            hydration experience designed to complement a healthy and balanced
            lifestyle.
          </p>

          <div className="flex items-center align-middle justify-center md:justify-start">
            <Link
              to="/productsrange"
              href="#about"
              className="inline-flex items-center justify-center w-auto md:w-44 px-5 py-3 mr-3 text-base font-medium 
              text-center text-textWhite rounded-full bg-primary
              hover:bg-primaryHover focus:ring-4 focus:ring-primary-300 dark:focus:ring-primaryLight"
            >
              Order Now
              <svg
                className="w-5 h-5 ml-2 -mr-1"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                  clip-rule="evenodd"
                ></path>
              </svg>
            </Link>
          </div>
        </div>

        {/* right div item md:w-1/2 */}
        <div className="mt-8 sm:mb-24 md:mt-1">
          <img
            src="/images/0sodium.png"
            alt="0 Sodium 100% Refreshment"
            className="w-128 lg:w-144"
          />
        </div>
      </div>
    </React.Fragment>
  );
};
